import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { URLs } from "common/lib/constants";
import { Button, Spinner } from "common/lib/components";
import { useLiquiditySelector } from "domains/liquidity/store/liquidity.selectors";
import { authApiReducer } from "domains/authentication/store/auth.api.reducer";
import { liquidityApiReducer } from "domains/liquidity/store/liquidity.api.reducer";

import "./AnonAccountModal.scss";

interface IProps {
  isVisible: boolean;
  handleCancel: () => void;
}

const AnonAccountModal = ({ isVisible, handleCancel }: IProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation([ "altQuotes", "common" ]);
  const { liquidity_request_id: LRId } = useLiquiditySelector();
  const [ logout, { isLoading: isLogoutLoading } ] = authApiReducer.useLogoutMutation();
  const [ updateLiquidityRequest, { isLoading } ] = liquidityApiReducer.useIsFormalProposalRequestedMutation();

  const handleContinueModal = async () => {
    if (!LRId) return;
    
    try {
      await updateLiquidityRequest({ 
        LRId, 
        changes: { 
          is_formal_proposal_requested: true,
        },
      });
      await logout();
      navigate(URLs.AUTH.SIGN_IN, { state: { LRId }, replace: true });
    } catch (error) {
      console.error('Error updating liquidity request:', error);
    }
  };

  return (
    <Modal
      className="ben-modal-anon-account"
      open={ isVisible }
      width={ 725 }
      onCancel={ handleCancel }
      onOk={ handleContinueModal }
      footer={ [
        <Button disabled={ isLoading } onClick={ handleCancel } key="back">
          {t("Cancel", { ns: "common" })}
        </Button>,
        <Button disabled={ isLoading } onClick={ handleContinueModal } type="primary" key="continue">
          {t("Continue", { ns: "common" })}
        </Button>,
      ] }
    >
      <Spinner spinning={ isLoading || isLogoutLoading }>
        <div className="ben-modal-anon-account-content">
          <h1>{t("AnonAccountModal.Title")}</h1>
          <p>
            {t("AnonAccountModal.Description")}
          </p>
        </div>
      </Spinner>
    </Modal>
  );
};

export default AnonAccountModal;
